/* eslint-disable object-curly-newline */
import Vue from 'vue';
import Router from 'vue-router';
import $store from './store';
import Home from '@/views/Home.vue';
import Start from '@/views/Start.vue';
import Quest from '@/views/quest/Index.vue';
import QuestInfo from '@/views/quest/Info.vue';
import QuestDefault from '@/views/quest/Default.vue';
import QuestClues from '@/views/quest/Clues.vue';
import Location from '@/views/location/Index.vue';
import LocationDefault from '@/views/location/Default.vue';
import LocationInvestigate from '@/views/location/Investigate.vue';
import Encounter from '@/views/Encounter.vue';
import QuestLocations from '@/views/quest/Locations.vue';
import Exit from '@/views/Exit.vue';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/start',
      name: 'start',
      component: Start,
    },
    {
      path: '/location',
      component: Location,
      props: true,
      children: [
        { path: '', name: 'location-default', component: LocationDefault },
        { path: 'investigate', name: 'location-investigate', component: LocationInvestigate },
      ],
      beforeEnter(to, from, next) {
        // console.log(`beforeEnter: ${to.name}`);
        if (!($store.state.currentGame.character || $store.state.currentGame.quest)) {
          return next('/');
        }
        return next();
      },
    },
    {
      path: '/encounter',
      name: 'encounter',
      component: Encounter,
      beforeEnter(to, from, next) {
        // console.log(`beforeEnter: ${to.name}`);
        if (!($store.state.currentGame.encounter || $store.state.currentGame.quest)) {
          return next('/');
        }
        return next();
      },
    },
    {
      path: '/quest',
      component: Quest,
      children: [
        { path: '', name: 'quest-default', component: QuestDefault },
        { path: 'info', name: 'quest-info', component: QuestInfo },
        { path: 'clues', name: 'quest-clues', component: QuestClues },
        { path: 'locations', name: 'quest-location', component: QuestLocations },
      ],
      beforeEnter(to, from, next) {
        if (!$store.state.currentGame.quest) {
          // eslint-disable-next-line
          console.error('attempting to navigate to a quest when one is not set');
          return next('/');
        }
        // console.log(to, from, next);
        return next();
      },
    },
    {
      path: '/exit',
      name: 'exit',
      component: Exit,
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
    },
    {
      // anything else that doesn't match - required for PWA
      path: '*', // or '/index.html'
      beforeEnter: (to, from, next) => {
        next('/');
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  const showLogo = (to.path === '/' || to.path === '/start');
  $store.commit('setShowLogo', showLogo);
  next();
});

export default router;
